import axios from "./axios"
import { ILogsParams } from "./types/logs"

export const apiCreateLog = (log: ILogsParams): Promise<undefined> =>
  axios
    .post("api/logs", {
      log,
    })
    .then((res) => res.data)
